import React, { useState } from 'react';
import Button from '../../../Components/Button/Button';
import { Theme } from '../../../Enums/Theme.enum';
import DefaultSettingsModal from './DefaultSettingsModal';

const DefaultSettingsWrapper: React.FC = () => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<>
			<Button
				title='component.defaultSettings.button'
				theme={Theme.BLUE}
				onClick={() => setIsOpen(true)}
				className='mt-4'
			/>
			{isOpen && (
				<DefaultSettingsModal isOpen onClose={() => setIsOpen(false)} />
			)}
		</>
	);
};

export default DefaultSettingsWrapper;
